import React from 'react';
import { Banner } from './error-banner.styles';
import { useRouter } from '../../providers/router/router-provider';
import ErrorIcon from '../../../../assets/ErrorIcon';

export const ErrorBanner = () => {
  const { error } = useRouter();

  return error ? (
    <Banner data-testid="error-banner">
      <div><ErrorIcon style={{ color: 'var(--cvna-color-red-2)' }} /></div>
      <div>{ error }</div>
    </Banner>
  ) : null;
};

export default ErrorBanner;